/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusVernehmlassungDetailDto } from '../../models/lexplus-vernehmlassung-detail-dto';

export interface VernehmlassungControllerFindOneDetailsByIdV1$Params {
  id: number;
}

export function vernehmlassungControllerFindOneDetailsByIdV1(http: HttpClient, rootUrl: string, params: VernehmlassungControllerFindOneDetailsByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusVernehmlassungDetailDto>> {
  const rb = new RequestBuilder(rootUrl, vernehmlassungControllerFindOneDetailsByIdV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusVernehmlassungDetailDto>;
    })
  );
}

vernehmlassungControllerFindOneDetailsByIdV1.PATH = '/v1/vernehmlassung/details/{id}';
